import React from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

import CRUDPage from './CRUDPage';
import LegoContextSummary from '../components/lego/LegoContextSummary';
import ModelContextEditor from '../components/lego/ModelContextEditor';
import MongoDocEditor from '../components/lego/MongoDocEditor';
import { LocalesSelector } from '../components/lego/LocalesSelector';
import { LocalesList } from '../components/lego/LocalesList';
import MultiButtonSwitch from '../components/common/editors/MultiButtonSwitch';
import submenuLegos from './menus/submenu-legos';

export default class WiringDiagramManager extends CRUDPage {
  constructor(props) {
    super(props, 'services/data/wiring-diagrams');
    this.submenu = submenuLegos;
  }

  getFacetFiltersComponent() {
    const { context, state } = this.state.facetFilters;
    const setFilter = (field, value) => {
      const filters = _.cloneDeep(this.state.facetFilters);
      _.isEmpty(value) ? delete filters[field] : filters[field] = value;
      this.onFiltersChange(filters);
    };

    return <span>
      <span style={{ width: '350px', paddingBottom: '2px' }} className={'inline-block zoom-75 ml-1'}>
        <ModelContextEditor value={context} onChange={v => setFilter('context', v)}/>
      </span>
      <span className={'zoom-90 ml-1'}>
        <MultiButtonSwitch nullable value={state} options={[{ value: 'published', label: 'Published' }, { value: 'draft', label: 'Draft' }]} onChange={v => setFilter('state', v)}/>
      </span>
    </span>;
  }

  getColumnsDefinition() {
    return [
      { content: 'Id', className: '' },
      { content: 'Locale', className: 'text-center' },
      { content: 'Context', className: '', sorter: (l) => l.context?.year },
      { content: 'Components', className: '' },
      { content: 'Source', className: '' },
    ];
  }

  getObjectColumns(doc) {
    const { _id, context, locales, state, data, source, updatedAt } = doc;
    const components = data?.components || [];
    const diagramsCount = _.sumBy(components, c => (c.diagrams || []).length);

    return [
      <td key={'id'}>
        <div><span className={'text-info small'}>{updatedAt ? dayjs(updatedAt).fromNow() : ''}</span></div>
        <div className={'text-secondary small'}>{_id}</div>
        {state !== 'published' ? <span className={'badge badge-danger'}>{state || 'unpublished'}</span> : null}
      </td>,
      <td key={'locales'} className={'text-center'}><LocalesList locales={locales}/></td>,
      <td key={'ctx'} className={'context-column text-left'}><LegoContextSummary context={context}/></td>,
      <td key={'components'}>
        <span className={'badge badge-info mr-1'}>{components.length} components</span>
        <span className={'badge badge-secondary mr-1'}>{diagramsCount} diagrams</span>
        <div className={'small text-secondary'}>{_.map(components, 'name').join(', ')}</div>
      </td>,
      <td key={'source'} className={'small text-info break-word-all'}>
        {_.map(source, (s, i) => <div key={i}>{s.provider} {s.articleId}
          {s.sectionUrl ? <a href={s.sectionUrl} target={'_blank'} className={'ml-1'}>link</a> : null}</div>)}
      </td>,
    ];
  }

  getObjectEditorComponent(obj, defaultOnSaveCbk, defaultOnCancelCbk) {
    const schema = {
      'locales': (value, onChange) => <LocalesSelector value={value} onChange={onChange}/>,
      'context': (value, onChange) => <ModelContextEditor value={value} onChange={onChange}/>,
    };
    return <MongoDocEditor obj={obj} extendSchema={schema} onSave={defaultOnSaveCbk} onCancel={defaultOnCancelCbk}/>;
  }
}
